/** "28 Jul 2026" — the format used on the index cards. */
export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatRelative(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const seconds = Math.round((Date.now() - then) / 1000);
  if (seconds < 10) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.round(seconds / 3600)}h ago`;
  return formatDate(iso);
}

/**
 * Search snippets arrive with U+0002 … U+0003 around each match. Split on those
 * sentinels rather than parsing HTML, so nothing from the database is ever
 * injected into the page as markup.
 */
export function splitSnippet(snippet: string): { text: string; hit: boolean }[] {
  return snippet
    .split(/[\u0002\u0003]/)
    .map((text, index) => ({ text, hit: index % 2 === 1 }))
    .filter((part) => part.text.length > 0);
}
